var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.999 31.033c3.852 0 7.705-1.466 10.637-4.398 5.863-5.867 5.863-15.407 0-21.27-5.863-5.864-15.407-5.864-21.271 0A14.992 14.992 0 00.968 15.999a15.01 15.01 0 0015.031 15.034zm9.817-5.217c-5.273 5.273-13.763 5.395-19.203.387l19.592-19.59c5.005 5.44 4.887 13.927-.389 19.203zM6.184 6.184a13.827 13.827 0 019.814-4.061c3.375 0 6.738 1.234 9.388 3.672L5.795 25.387C.79 19.947.908 11.457 6.184 6.184z"}));
}

Cancel.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Cancel;

Cancel.default = Cancel;
